import styled from '@emotion/styled'
import { Paragraph } from 'components/patterns'
import { themeColor } from 'utils/styles'

export const StyledList = styled.ul`
  padding-top: 15px;
`

export const StyledParagraph = styled(Paragraph)`
  padding-top: 10px;
`

export const ReadOnlyContainer = styled.div`
  border-top: 1px solid ${themeColor('sAndGGroupBoarderColor')};
  padding: 15px;
  margin-top: 15px;
`
